export var contentWrapper = 'flex flex-row items-center justify-between py-4';
export var actionTitle = 'text-base font-medium text-primary truncate';
export var actionTitleInput = 'font-semibold text-base leading-snug text-textDark truncate';
export var actionSubTitle = 'mt-2 items-center text-sm text-textLight truncate';
export var actionIcon = 'h-4 w-4 text-secondary';
export var actionListItemContainer = 'border border-t-0 border-r-0 border-l-0 border-dashed border-color-uiLight block';
export var actionParagraphWrapper = 'min-w-0 justify-between flex flex-col';
//# sourceMappingURL=action-list-item.styles.js.map